<!-- //
更换主题色
@auth xuyd
@date 2024-05-01
//-->
<template>
  <el-tooltip content="主题色">
    <div class="flex-row flex-valign-center">
    <div class="mr10" style="color: #FFFFFF;">主题色</div>
    <el-color-picker
        v-model="theme"
        size="small"
        :predefine="['#409EFF',
        '#3A71A8','#1E47AB','#304156',
        '#212121','#11a983', '#13c2c2',
        '#6959CD', '#f5222d', ]"
        class="theme-picker"
        popper-class="theme-picker-dropdown"
    />
    </div>
  </el-tooltip>
</template>

<script>
const version = require('element-ui/package.json').version // element-ui version from node_modules
const ORIGINAL_THEME = '#409EFF' // default color

const fs = require('fs'); // // CommonJS
import { readFileSync } from 'fs' // ES6
const path = require('path');

export default {
  data() {
    return {
      chalk: '', // content of theme-chalk css
      theme: this.defaultTheme
    }
  },
  computed: {
    defaultTheme() {
      return this.$store.getters.theme
    }
  },
  watch: {
    defaultTheme: {
      handler: function (val, oldVal) {
        this.theme = val
      },
      immediate: true
    },
    async theme(val) {
      // console.log("====theme====>", val)
      await this.handleThemeChange(val)
      await this.$store.dispatch("doSaveSettings", {theme: val});
    }
  },
  created() {
    if (this.defaultTheme !== ORIGINAL_THEME) {
      this.handleThemeChange(this.theme)
    }
  },

  methods: {
    async handleThemeChange(val) {
      const oldVal = this.chalk ? this.theme : ORIGINAL_THEME
      if (typeof val !== 'string') return
      const themeCluster = this.getThemeCluster(val.replace('#', ''))
      const originalCluster = this.getThemeCluster(oldVal.replace('#', ''))

      const getHandler = (variable, id) => {
        return () => {
          const originalCluster = this.getThemeCluster(ORIGINAL_THEME.replace('#', ''))
          const newStyle = this.updateStyle(this[variable], originalCluster, themeCluster)

          let styleTag = document.getElementById(id)
          if (!styleTag) {
            styleTag = document.createElement('style')
            styleTag.setAttribute('id', id)
            document.head.appendChild(styleTag)
          }
          styleTag.innerText = newStyle
        }
      }

      if (!this.chalk) {
        let url = `https://unpkg.com/element-ui@${version}/lib/theme-chalk/index.css`
        this.chalk = await this.getCSSString(url, 'chalk')
        // console.log('CSS文件内容:', this.chalk);

      // TODO 如何加载本地
      //   const cssPath = path.join(__dirname, 'node_modules/element-ui/lib/theme-chalk/index.css');
      //   try {
      //     const data = readFileSync(cssPath, 'utf8');
      //     console.log('CSS文件内容:', data);
      //     this.chalk = data.replace(/@font-face{[^}]+}/, '');
      //   } catch (err) {
      //     console.error('读取文件时发生错误:', err);
      //   }
      //
      //   fs.readFile(cssPath, 'utf8', (err, data) => {
      //     if (err) {
      //       console.error('读取文件时发生错误:', err);
      //       return;
      //     }
      //     console.log('CSS文件内容:', data);
      //
      //   });
      }

      const chalkHandler = getHandler('chalk', 'chalk-style')

      chalkHandler()

      const styles = [].slice.call(document.querySelectorAll('style'))
          .filter(style => {
            const text = style.innerText
            return new RegExp(oldVal, 'i').test(text) && !/Chalk Variables/.test(text)
          })
      styles.forEach(style => {
        const {innerText} = style
        if (typeof innerText !== 'string') return
        style.innerText = this.updateStyle(innerText, originalCluster, themeCluster)
      })

      this.$emit('change', val)
    },

    updateStyle(style, oldCluster, newCluster) {
      let newStyle = style
      oldCluster.forEach((color, index) => {
        newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index])
      })
      return newStyle
    },

    getCSSString(url, variable) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            let data = xhr.responseText.replace(/@font-face{[^}]+}/, '')
            resolve(data)
          } else {
            console.log("加载失败：" + url)
          }
        }
        xhr.open('GET', url)
        xhr.send()
      })
    },

    getThemeCluster(theme) {
      const tintColor = (color, tint) => {
        let red = parseInt(color.slice(0, 2), 16)
        let green = parseInt(color.slice(2, 4), 16)
        let blue = parseInt(color.slice(4, 6), 16)

        if (tint === 0) { // when primary color is in its rgb space
          return [red, green, blue].join(',')
        } else {
          red += Math.round(tint * (255 - red))
          green += Math.round(tint * (255 - green))
          blue += Math.round(tint * (255 - blue))

          red = red.toString(16)
          green = green.toString(16)
          blue = blue.toString(16)

          return `#${red}${green}${blue}`
        }
      }

      const shadeColor = (color, shade) => {
        let red = parseInt(color.slice(0, 2), 16)
        let green = parseInt(color.slice(2, 4), 16)
        let blue = parseInt(color.slice(4, 6), 16)

        red = Math.round((1 - shade) * red)
        green = Math.round((1 - shade) * green)
        blue = Math.round((1 - shade) * blue)

        red = red.toString(16)
        green = green.toString(16)
        blue = blue.toString(16)

        return `#${red}${green}${blue}`
      }

      const clusters = [theme]
      for (let i = 0; i <= 9; i++) {
        clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
      }
      clusters.push(shadeColor(theme, 0.1))
      return clusters
    }
  }
}
</script>

<style>
.theme-message,
.theme-picker-dropdown {
  z-index: 99999 !important;
}

.theme-picker-dropdown .el-color-dropdown__link-btn {
  display: none;
}
</style>
